<template>
  <button class="btn" v-on="$listeners"><slot /> {{ text }}</button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>
